<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="SERIES1">Published Volumes</p>
<p class="SERIES2"><em class="italic">The Election of Grace: A Riddle without a Resolution?</em><br/>Stephen N. Williams</p>
<p class="SERIES2"><em class="italic">The God We Worship: An Exploration of Liturgical Theology</em><br/>Nicholas Wolterstorff</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wolterstorff_The_God_We_Worship_text_CC-1.vue?628f0b35